import { Button, Flex, Text } from "@mantine/core";
import { deleteApplicant, getApplicantList } from "../../api/applicantApi";
import TableDeleteButton from "../common/Buttons/TableDeleteButton";
import TagBadges from "../common/TagBadges";
import { useNavigate } from "react-router";
import { theme } from "../../theme";
import CustomSelect from "../common/Inputs/CustomSelect";
import DataTable, { Column } from "../common/Table/DataTable";
import { useTableQuery } from "../../hooks/useTableQuery";
import { useDeleteWithConfirm } from "../../hooks/useDeleteWithConfirm";
import { useAuth } from "../../context/AuthContext";

const ApplicantTable = () => {
  const { tagSelectData, departmentSelectData } = useAuth();
  const navigate = useNavigate();

  const table = useTableQuery({ fetcher: getApplicantList });

  const { askDelete, modal } = useDeleteWithConfirm({
    deleteFn: deleteApplicant,
    onDeleted: table.refetch,
    title: "Aday Sil",
    text: "Bu adayı silmek istediğinizden emin misiniz?",
  });

  const columns: Column[] = [
    {
      key: "name",
      header: "Ad Soyad",
      width: "22%",
      render: (row) => (
        <Text fw={400} size="md" style={{ color: "#111827" }}>
          {row?.name}
        </Text>
      ),
    },
    {
      key: "phone",
      header: "Telefon",
      width: "18%",
      render: (row) => (
        <Text size="md" fw={400} style={{ color: "#111827" }}>
          {row?.phone || "—"}
        </Text>
      ),
    },
    {
      key: "departments",
      header: "Departman",
      width: "20%",
      render: (row) => (
        <TagBadges
          max={2}
          tags={(row?.departments ?? []).map((d: any) => ({
            ...d,
            kind: "department",
          }))}
        />
      ),
    },
    {
      key: "tags",
      header: "Rol",
      width: "20%",
      render: (row) => (
        <TagBadges
          max={2}
          tags={row?.tags ?? []}
        />
      ),
    },
    {
      key: "actions",
      header: "İşlemler",
      width: "20%",
      headerAlign: "right",
      render: (row) => (
        <Flex align="center" gap={10} justify="flex-end">
          <Button
            size="xs"
            variant="filled"
            color={theme.colors.brand.normal}
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/employees/new`, { state: { applicant: row } });
            }}
          >
            İşe Al
          </Button>
          <TableDeleteButton
            onClick={(e: any) => {
              e.stopPropagation();
              askDelete(row);
            }}
          />
        </Flex>
      ),
    },
  ];

  return (
    <>
      <DataTable
        columns={columns}
        rows={table.rows}
        loading={table.loading}
        emptyText="Aday bulunamadı."
        searchValue={table.search}
        onSearchChange={table.setSearch}
        searchPlaceholder="Aday ara..."
        toolbar={
          <>
            <CustomSelect
              placeholder="Departman"
              data={departmentSelectData}
              clearable
              onChange={(value: any) =>
                table.setFilter("department", value ?? undefined)
              }
            />
            <CustomSelect
              placeholder="Rol"
              data={tagSelectData.role}
              clearable
              onChange={(value: any) =>
                table.setFilter("role", value ?? undefined)
              }
            />
          </>
        }
        page={table.page}
        totalPages={table.totalPages}
        onPageChange={table.setPage}
        limit={table.limit}
        onLimitChange={table.setLimit}
      />
      {modal}
    </>
  );
};

export default ApplicantTable;
